import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import IconTooltip from 'ui/utils/IconTooltip'

export type QuestionTooltipProps = {
  children: any
}

const useStyles = makeStyles()(() => ({
  labelWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1.5,
  },
}))

const QuestionTooltip: React.FC<QuestionTooltipProps> = ({
  children,
}: QuestionTooltipProps) => (
  <IconTooltip icon={<HelpOutlineIcon color="action" />}>
    {children}
  </IconTooltip>
)

export type QuestionTooltipWithLabelProps = {
  label: React.ReactNode
  children: any
}

export const QuestionTooltipWithLabel: React.FC<
  QuestionTooltipWithLabelProps
> = ({ label, children }: QuestionTooltipWithLabelProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.labelWrapper}>
      {label}
      <QuestionTooltip>{children}</QuestionTooltip>
    </div>
  )
}

export const UploadQuestionTooltipMessage = () => {
  const { t } = useTranslation()
  return (
    <>
      {t('PDF, PNG, JPG, JPEG, HEIC, WebP形式のファイルを添付できます。')}
      {t('最大5ファイル、1ファイル5MBまで添付可能です。')}
    </>
  )
}

export const UploadQuestionTooltip: React.FC = () => {
  const { t } = useTranslation()
  return (
    <QuestionTooltip>
      {t('PDF, PNG, JPG, JPEG, HEIC, WebP形式のファイルを添付できます。')}
    </QuestionTooltip>
  )
}

export default QuestionTooltip
